'use client';

import classes from "./public_header.module.css";
import link_classes from "./public_header_item.module.css";
import { forwardRef, Fragment, useContext, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import Link from 'next/link';
import { usePathname } from "next/navigation";
import CustomSVG from '../common/svg';
import ChevronDown from '@/assets/svg/icons/chevron-down.svg';
import ChevronUp from '@/assets/svg/icons/chevron-up.svg';
import AuthContext from "@/providers/auth-context";
import Home from '@/assets/svg/icons/home.svg';
import Layers from '@/assets/svg/icons/layers.svg';
import List from '@/assets/svg/icons/list.svg';
import Heart from '@/assets/svg/icons/heart.svg';
import Users from '@/assets/svg/icons/users.svg';
import CoinStack from '@/assets/svg/budget_icons/coin-stack.svg';
import MessageCircle from '@/assets/svg/icons/message-circle.svg';
import Grid from '@/assets/svg/icons/grid.svg';
import Wifi from '@/assets/svg/icons/wifi.svg';
import Star from '@/assets/svg/icons/star.svg';

const planner_list = [
    {id: 1, icon: Home, name: "Összefoglalás", url: ""},
    {id: 2, icon: Layers, name: "Programok", url: "/programok"},
    {id: 3, icon: List, name: "Teendőim", url: "/teendoim"},
    {id: 4, icon: Heart, name: "Szolgáltatók", url: "/szolgaltatok"},
    {id: 5, icon: Users, name: "Vendéglista", url: "/vendeglista"},
    {id: 6, icon: CoinStack, name: "Költségvetés", url: "/koltsegvetes"},
    {id: 7, icon: MessageCircle, name: "Üzenetek", url: "/uzenetek"},
    {id: 8, icon: Grid, name: "Ültetési rend", url: "/ultetesi-rend"},
    {id: 9, icon: Wifi, name: "Weboldal", url: "/weboldal"},
    //{id: 10, icon: Star, name: "Esküvői segédlet", url: "/eskuvoi-segedlet"}
]

const CustomToggle = forwardRef(function CustomToggle({ children, onClick, path, active }, ref) {
    return (
        <div ref={ref} className="d-flex h-100 align-items-center pointer" onClick={(e) => {e.preventDefault();}}>
            <Link href={"/szervezom"} className={`show-on-pc-480 h-100 d-flex flex-row align-items-center gap-1 ${link_classes.link} ${(path.startsWith("/szervezom")) ? link_classes.active : ''}`} onClick={onClick} >
                Szervezőm
                <CustomSVG className="stroke-gray-700" SvgFunction={active ? ChevronUp : ChevronDown} height={24} width={24} />
            </Link> 
        </div>
    )
});

export default function PublicHeaderPlannerDropdown({}) {
    const path = usePathname();
    const [isOpen, setIsOpen] = useState(false);
    const {weddingId, userData} = useContext(AuthContext);
    const isLoggedIn = userData?.id > 0;

    const handleMouseEnter = () => { setIsOpen(true); };
    const handleMouseLeave = () => { setIsOpen(false); };

    return <Dropdown show={isOpen} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className='h-100' >
        <Dropdown.Toggle as={CustomToggle} active={isOpen} path={path} onClick={handleMouseLeave} />
        <Dropdown.Menu onMouseEnter={handleMouseEnter} className={`${classes["provider-dropdown"]}`}>
            <div className={`${classes["provider-dropdown-inner"]} ${classes["planner"]} p-2`}>
                {planner_list.map(p => <div key={`nav-planner-item-${p.id}`} className={`${classes["provider-dropdown-element"]}`}>
                    <Link href={isLoggedIn ? `/szervezom/${weddingId}${p.url}` : `/szervezom${p.url}`} title={p.name} className={`${classes["provider-dropdown-link"]} color-gray-700 text-md-medium d-flex flex-row align-items-center gap-4`} onClick={handleMouseLeave} >
                        <CustomSVG className={`stroke-gray-800 circle-stroke-gray-800 flex-shrink-0`} SvgFunction={p.icon} height={24} width={24} />
                        {p.name}
                    </Link>
                </div>)}
            </div>
        </Dropdown.Menu>
    </Dropdown>
}